import { Add } from "@mui/icons-material";

export default function EmptyRecipe(){
    return <div className="empty grid center">
        <h1>No Recipes</h1>
        <p>Add a new recipe by clicking <Add/></p>
    </div>
}